<app-header></app-header>

<section class="bredcrumb">
    <div class="container">
        <ul class="brd-nav">
            <li> <a [routerLink]="['/']"> Home </a></li>
            <li> <span> Plans </span></li>
        </ul>
    </div>
</section>

<section class="single-page order-list padd-row">
    <div class="container">
        <div class="home_main">
            <div class="home_posts-main">
                <div class="row">
                    <div class="col-md-6">
                        <div *ngFor="let plan of plans" class="home_post_box_new home_posts_box cmn_bdr_wh_bg">


                            <div class="home_posts_box_heading">

                                <div class="home_rightside_user_box">

                                    <div class="home_rightside_user_box_cnt plansList">
                                        <h4> {{ plan.name }} </h4>
                                        <h5 class="cursor-pointer">
                                            <strong>₹ {{plan?.price}}</strong>
                                        </h5>
                                        <p> {{ plan.description }}</p>
                                        <!-- <hr class="w-100"> -->
                                        <!-- <h4>Features</h4> -->
                                        <!-- <ul class="featuresList">
                                            <li *ngFor="let feature of plan.features">
                                                <i class="fa fa-check mr-2" aria-hidden="true"></i>
                                                Unlimited {{ feature }} booking
                                            </li>
                                        </ul> -->
                                        <div class="row">
                                            <div class="col-md-12 text-right">
                                                <button class="avail_button" (click)="payWithRazor(plan)" *ngIf="!plan?.isSubscribed">Avail Now</button>
                                                <button class="avail_button" *ngIf="!!plan?.isSubscribed">Currently Active</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</section>